/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import ScrollMagic from 'ScrollMagic';
import animationGSAP from 'animation.gsap';
import addIndicators from 'debug.addIndicators';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '#wpadminbar' ).length ) {
        $( '.desktop-navbar' ).css( 'top', $( '#wpadminbar' ).outerHeight() );
      }

      if ( $( '#wpadminbar' ).length ) {
        $( '.mobile-navbar' ).css( 'top', $( '#wpadminbar' ).outerHeight() );
      }

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav-mobile' ).slideToggle();
      } );

      $( '.sub-menu-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).data( 'toggle-target' ) ).slideToggle();
      } );

      $( `a[href="#consultation-popup"]` ).magnificPopup( {
        type: 'inline',
        mainClass: 'consultation-popup__container',
      } );

      // WOOCOMMERCE form STUFFS
      $( '.form-skin input, .form-skin textarea, .cart .form-skin_wrapper input, .cart .form-skin_wrapper textarea' ).focus( function( e ) {
        let container = $( this ).closest( 'span' );
        if ( $( container ).length === 0 ) {
          container = $( this ).closest( '.gfield' );
        }

        $( container ).addClass( 'is-focused' );
      } );

      $( '.form-skin input, .form-skin textarea, .cart .form-skin_wrapper input, .cart .form-skin_wrapper textarea' ).blur( function( e ) {
        const containerTwo = $( this ).closest( '.is-focused' );
        if ( $( this ).val().length === 0 ) {
          $( containerTwo ).removeClass( 'is-focused' );
        }
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // console.log( document.querySelector( '.navbar' ).offsetHeight );

      // document.querySelector( '.primary-nav' ).offsetHeight;


      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        // $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        // $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      $( 'a.btn--schedule, .btn--schedule a' ).magnificPopup( {
        type: 'inline',
        preloader: false,
        // focus: '#username',
        items: {
          src: '#schedule-popup',
          type: 'inline',
        },
      } );
      $( 'a.btn--leaving, .btn--leaving a' ).magnificPopup( {
        type: 'inline',
        preloader: false,
        midClick: true,
        items: {
          src: '#leaving-popup',
          type: 'inline',
        },
      } );
      $( '.btn--leaving' ).click( function( e ) {
        e.preventDefault;
        const newPage = $( this ).attr( 'href' );
        $( '#leaving-popup .continue-link' ).attr( 'href', newPage );
        $.magnificPopup.open( {
          items: {
            src: '#leaving-popup',
          },
          alignTop: false,
          closeBtnInside: true,
          type: 'inline',
        } );
      } );
      $( '.close-leaving-popup' ).on( 'click', function() {
        $.magnificPopup.close();
      } );

      // Switch data-src to source on any image with class lazy
      const switchImageSrc = ( images ) => {
        images.each( function( index, element ) {
          if ( $( element ).hasClass( 'll-lazy' ) ) {
            const sourceSet = $( element ).attr( 'data-srcset' );
            const source = $( element ).attr( 'data-src' );
            $( element ).attr( 'srcset', sourceSet );
            $( element ).attr( 'src', source );
            $( element ).removeClass( 'll-lazy' );
          }
        } );
      };

      // add event listener to switch any images with custom lazy load
      $( '*[data-lazy]' ).each( function( index, element ) {
        $( this ).on( 'click', function() {
          const images = $( $( this ).attr( 'data-lazy' ) ).find( '.ll-lazy' );
          // load images
          if ( images.length > 0 ) {
            switchImageSrc( images );
          }
        } );
      } );

      const linkTree = document.querySelector( '.link-tree' );
      const headerVisibility = document.querySelector( '.header-visibility' );
      const footerVisibility = document.querySelector( '.footer-visibility' );
      if ( linkTree ) {
        $( headerVisibility ).toggleClass( 'hidden' );
        $( footerVisibility ).toggleClass( 'hidden' );
        $( 'body' ).css( 'padding-top', 0 );
      } else {
        $( headerVisibility ).removeClass( 'hidden' );
        $( footerVisibility ).removeClass( 'hidden' );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
